<template>
    <div class="container py-5">
        <div class="breadcrumbs py-5">
            <a href="/home-bat">Inicio</a>
            <a class="link" href="#">Carrito de compras</a>
        </div>

        <div class="header-catalog pt-4">
            <h5>Carrito de compras</h5>
            <div class="step-car">
                <div class="row">
                    <div class="col d-flex flex-column align-items-center step mx-2 ">
                        <div class="icon-step-check mb-2">
                            <img src="/img-version2/icons/tick-circle.svg" alt="tick-circle">
                        </div>
                        <span class="text-check">Confirmación</span>
                    </div>
                    <div class="col d-flex flex-column align-items-center step mx-2" >
                        <div :class="step === 1 ? 'icon-step' : 'icon-step-check'" class="mb-2">
                            <img v-if="step === 1" src="/img-version2/icons/lock.svg" alt="lock">
                            <img v-else src="/img-version2/icons/tick-circle-finish.svg" alt="lock">
                        </div>
                        <span :class="step === 1 ? 'text-lock' : 'text-check'">Datos <br>Personales</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid py-5 text-bat">
            <div class="row justify-content-between">
                <div class="col-12 col-md-12 col-lg-6">
                    <div v-if="step === 1">
                        <div v-for="(product, index) in local_products" class="card-product-cart mx-auto mb-2">
                            <div class="header">
                                <div class="row justify-content-between">
                                    <div class="col-6 col-md-6 title-cart-product">
                                        <p>{{ product.NAME }} <span>{{ product.CATEGORY }}</span></p>
                                    </div>
                                    <div class="col-6 col-md-6 trash-cart">
                                        <button @click="delete_product_guid = product.GUID; modal_delete_product = true"><img src="/img-version2/icons/trash.svg" alt="trash"></button>
                                    </div>
                                </div>
                            </div>

                            <div class="content">
                                <div class="row justify-content-between">
                                    <div class="col-4 col-md-6 info-cart-product">
                                        <p>Codigo:<span>{{ product.REFERENCE }}</span></p>
                                        <p>{{ (product.POINTS_UNIT_VALUE + product.POINTS_UNIT_SHIPPING) * product.QUANTITY }} puntos</p>
                                    </div>
                                    <div class="col-4 col-md-6 img-product-cart">
                                        <img :src="url_media + (product.PRODUCT_IMAGE !== null ? product.PRODUCT_IMAGE.replace('~/', '') : 'image.png')" :alt="product.NAME">
                                    </div>
                                </div>
                            </div>

                            <div class="footer">
                                <div class="count mb-1">
                                    <span class="less" @click="changeQuantity(index, 'remove')">-</span>
                                    <label>{{ product.QUANTITY }} Und</label>
                                    <span class="plus" @click="changeQuantity(index, 'add')">+</span>
                                </div>
                                <p class="mb-0">{{ product.INVENTORY }} uds <span>disponibles</span></p>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="form-cart mb-3">
                            <form action="" class="d-flex flex-column">
                                <label for="email"  id="label-1">E-mail *</label>
                                <input v-model="email" type="text" name="email">
                                <div v-if="has_recharge" class="select-cart mb-2">
                                    <label for="" id="label-9">Operador *</label>
                                    <select v-model="selected_operator" class="mt-1">
                                        <option value=""></option>
                                        <option value="CLARO">Claro</option>
                                        <option value="MOVISTAR">Movistar</option>
                                        <option value="TIGO">Tigo</option>
                                        <option value="UFF">Uff</option>
                                        <option value="UNE">Une</option>
                                        <option value="KALLEY">Kalley</option>
                                        <option value="WINGS">Wings</option>
                                        <option value="UNICORN">Unicorn</option>
                                        <option value="VIRGIN">Virgin</option>
                                        <option value="AVANTEL">Avantel</option>
                                        <option value="EXITO">Exito</option>
                                        <option value="ETB">Etb</option>
                                        <option value="PODEROSA">Poderosa</option>
                                        <option value="FLASH">Flash</option>
                                    </select>
                                </div>
                                <label for="cel"  id="label-2">Celular *</label>
                                <input v-model="cel" type="text" name="cel">
                                <label for=""  id="label-3">Departamento *</label>
                                <select v-model="state_id" @change="getCities">
                                    <option v-for="state in states" :value="state.id_departments">{{ state.name }}</option>
                                </select>
                                <label for=""  id="label-4">Ciudad *</label>
                                <select v-model="city_id">
                                    <option v-for="city in cities" :value="city.id_city">{{ city.name_city }}</option>
                                </select>
                                <label for="" id="label-5">Dirección *</label>
                                <input v-model="address" type="text" name="">
                                <!--                                <label for="postal_code" id="label-6">Código Postal</label>-->
                                <!--                                <input v-model="postal_code" type="text" name="postal_code">-->
                                <label for="name"  id="label-7">Nombre completo *</label>
                                <input v-model="name" type="text" name="name">
                                <label for="additional_info" id="label-8">Instrucciones de entrega</label>
                                <input type="text" v-model="delivery_instructions" name="additional_info" placeholder="apartamento, torre, piso, etc...">
                                <div class="check-form-cart d-flex align-items-start">
                                    <input v-model="check" type="checkbox" name="check">
                                    <span class="ps-1">Soy consiente que los bonos digitales llegan por el correo electrónico o al numero celular suministrado en este formulario y los productos físicos a la dirección diligenciada.</span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-12 col-lg-6">
                    <div class="card-points-cart mx-auto">
                        <div class="header py-3">
                            <h6>Resumen de puntos</h6>
                        </div>
                        <div class="descrip-puntos bg-points-dark py-1">
                            <p>Puntos Disponibles</p>
                            <span>{{ numberFormat(points_user) }} puntos</span>
                        </div>
                        <div class="descrip-puntos py-1">
                            <p>Total carrito</p>
                            <span>{{ numberFormat(local_total_points) }} puntos</span>
                        </div>
                        <div class="descrip-puntos bg-points-dark py-1">
                            <p>Saldo de puntos</p>
                            <span>{{ numberFormat(points_user-local_total_points) }} puntos</span>
                        </div>
                        <div v-if="points_user-local_total_points < 0" class="text-danger px-3">
                            No tienes los suficientes puntos para redimir estos productos
                        </div>
                    </div>
                    <div v-if="errors.length > 0" class="card mt-2">
                        <div class="card-body">
                            Los siguientes campos contienen errores o estan vacios
                            <ul>
                                <li v-for="error in errors">{{ error }}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="next-button my-4">
                        <br>
                        <a v-if="step === 1" href="/categoria-catalogo">Cancelar</a>
                        <a v-else class="cursor-pointer" @click="step = 1">Anterior</a>
                        <div v-if="step === 1">
                            <button v-if="points_user-local_total_points >= 0 && local_products.length > 0" @click="step = 2" class="btnBlue">Siguiente</button>
                            <button v-else class="btnBlue disabled">Siguiente</button>
                        </div>
                        <div v-else>
                            <button v-if="(points_user-local_total_points >= 0) && local_products.length > 0 && (loading !== 0 || redemption_success === true)" class="bntBlue"><i v-if="loading" class="fa-solid fa-spinner fa-spin-pulse"></i> Redimir</button>
                            <button v-else-if="(points_user-local_total_points >= 0) && local_products.length > 0" @click="validateFields()" class="btnBlue">Redimir</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            :visible.sync="modal_delete_product"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            key="delete_product_modal"
            :show-close="false">
            <div class="modals">
                <img src="/img-version2/modal/trash.svg" alt="image 8">
                <h6 class="my-3 mx-auto tituloConfirmar">¿Estás seguro que deseas <br> eliminar este producto?</h6>
                <div class="modals d-flex align-items-center flex-column justify-content-center">
                    <div class="row">
                        <div class="col-6">
                            <div class="buttonOne" type="buttoNot" @click="modal_delete_product = false">No, volver</div>
                        </div>
                        <div class="col-6">
                            <div class="buttonTwo" type="buttoYes" @click="deleteProduct(delete_product_guid)">Sí, eliminar</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync="modal_redemption_success"
            :width="$mq ==='sm' ? '90%' : '25%'"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            key="redemption_success">
            <div class="modals d-flex align-items-center flex-column justify-content-center">
                <img src="/img-version2/modal/tick-circle.svg" alt="image 8">
                <h6 class="my-3">Redención exitosa</h6>
                <p class="my-3">Sus productos llegarán en los<br> próximos días</p>
                <div class="moldals col-12 mt-5">
                    <div class="buttonAccept mx-auto" @click="cartSuccess()">Aceptar</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        products: {
            default: [],
        },
        url_media: {
            default: null,
        },
        points_user: {
            default: 0,
        },
        total_points: {
            default: 0,
        },
        type_recharge: {
            default: 3,
        },
        type_physic: {
            default: 2,
        },
        customer_id: {
            default: null,
        },
        program_id: {
            default: 0,
        },
        prefix_order_source: ''
    },
    data() {
        return {
            loading: 0,
            step: 1,
            states: null,
            cities: null,
            local_total_points: 0,
            redemption_success: false,
            local_products: [],
            errors: [],
            email: '',
            cel: '',
            state_id: '',
            city_id: '',
            address: '',
            postal_code: '',
            name: '',
            delivery_instructions: '',
            check: false,
            has_recharge: false,
            has_physic: false,
            selected_operator: '',
            modal_delete_product: false,
            modal_redemption_success: false,
            delete_product_guid: 0,
            guid_cart: '',
            products_data: [],
        }
    },
    mounted () {
        this.local_total_points = this.total_points
        this.local_products = this.products
        this.getStates()
        for(var product of this.products){
            if(product.PRODUCT_TYPE_ID === this.type_recharge){
                this.has_recharge = true
            }
            if(product.PRODUCT_TYPE_ID === this.type_recharge){
                this.has_physic = true
            }
        }
    },
    methods: {
        numberFormat(number) {
            const exp = /(\d)(?=(\d{3})+(?!\d))/g
            const rep = '$1,'
            let arr = number.toString().split('.')
            arr[0] = arr[0].replace(exp,rep)
            return arr[1] ? arr.join('.'): arr[0]
        },
        getStates(){
            this.loading++
            axios.get(`/list-department`)
                 .then(({data}) => {
                     this.city_id = ''
                     this.states = data.data
                     this.loading--
                 })
        },
        getCities(){
            this.loading++
            axios.get(`list-city/${this.state_id}`)
                 .then(({data}) => {
                     this.cities = data.data
                     this.loading--
                 })
        },
        validateFields(){
            this.loading++
            this.errors = []
            if(this.name === ''){
                this.errors.push('Nombre completo')
            }
            if(this.email === ''){
                this.errors.push('E-mail')
            }
            if(this.cel === '') {
                this.errors.push('Celular')
            } else if(isNaN(this.cel)) {
                this.errors.push('el campo celular No puede contener letras')
            }
            if(this.state_id === ''){
                this.errors.push('Departamento')
            }
            if(this.city_id === ''){
                this.errors.push('Ciudad')
            }
            if(this.address === ''){
                this.errors.push('Dirección')
            }
            // if(this.postal_code === ''){
            //     this.errors.push('Código Postal')
            // }
            if(this.check === false){
                this.errors.push('Debes ser conciente de los medios de entrega de las redenciones')
            }
            if(this.has_recharge && this.selected_operator === ''){
                this.errors.push('Operador')
            }
            this.loading--
            if(this.errors.length === 0){
                this.completeCart()
            }
        },
        deleteProduct(product_guid){
            var dataSend = {
                "guid": product_guid,
            }
            axios.post('/delete-product-shopping-cart', dataSend).then(
                ({data}) => {
                    this.local_products = data.products
                    this.local_total_points = data.total_points
                    this.$emit('products-cart', data.products)
                    this.modal_delete_product = false
                    this.delete_product_guid = 0
                })
        },
        completeCart(){
            this.loading++
            this.parseProducts()
            this.guid_cart = this.createGuid()
            var isProductTypeFisico = this.has_physic
            var isRecharge = this.has_recharge
            var cityIdUser = this.city_id
            var data_form = {
                "name": this.name,
                "email": this.email,
                "PhoneNumber": this.cel,
                "state_id": this.state_id,
                "city_id": this.city_id,
                "address": this.address,
                "postal_code": this.postal_code,
                "AditionalInformation": this.delivery_instructions,
            }
            var dataSend = {
                "ProgramId": this.program_id,
                "CustomerId": this.customer_id,
                "ShippingInformation": {
                    // "Guid": "sample string 1",
                    "CustomerId": this.customer_id,
                    "Address": this.address,
                    "CityId": this.city_id,
                    "PhoneNumber": this.cel,
                    "OptionalPhoneNumber": null,
                    "Email": this.email,
                    "AditionalInformation": this.delivery_instructions,
                    "MobileOperator": this.selected_operator??null,
                    "MobileNumber": this.cel,
                    "Active": true,
                    "IsNew": true
                },
                "OrderSource": `${this.prefix_order_source}  BAT Web`,
                "Cart": this.products_data,
                "ExtendedProperties": [{
                    "Guid": this.guid_cart,
                    "Name": "Redención",
                    "DisplayName": this.has_recharge ? this.selected_operator : "Redención",
                    "ValueX": isRecharge ? this.cel : "Conecta2",
                    "Format": "conecta2",
                    "OrderGuid": ""
                }]
            };
            var parseData = {
                "data_form": data_form,
                "arguments": dataSend,
                "total_points": this.local_total_points,
                "is_redeem_now": true
            }

            axios.post('/redeem-shopping-cart', parseData).then(
                ({data}) => {
                    this.redemption_success = true
                    this.modal_redemption_success = true
                }).finally(() => {
                this.loading--
            })
        },
        createGuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        parseProducts() {
            for(var product of this.local_products){
                var productCurrent = {
                    "Guid": product.GUID,
                    "ReferenceGuid": product.REFERENCE_GUID,
                    "Quantity": product.QUANTITY,
                    "CustomerId": product.CUSTOMER_ID,
                    "ProgramId": product.PROGRAM_ID,
                    "PointsUnitValue": product.POINTS_UNIT_VALUE,
                    "MoneyUnitValue": product.MONEY_UNIT_VALUE,
                    "PointsUnitShipping": product.POINTS_UNIT_SHIPPING,
                    "MoneyUnitShipping": product.MONEY_UNIT_SHIPPING,
                    "TaxPercent": product.TAX_PERCENT,
                    "PointsPercent": product.POINTS_PERCENT,
                    "Sendable": product.SENDABLE,
                    "RegisterDate": product.REGISTER_DATE,
                }
                this.products_data.push(productCurrent)
            }
        },
        cartSuccess(){
            if(this.loading === 0){
                this.loading++
                window.location.href = "/categoria-catalogo"
            }
        },
        changeQuantity(index, action){
            if(action === 'remove' && this.local_products[index].QUANTITY > 1){
                this.local_products[index].QUANTITY--
                this.local_total_points = this.local_total_points-(this.local_products[index].POINTS_UNIT_VALUE + this.local_products[index].POINTS_UNIT_SHIPPING)
            }else if(action === 'add' && this.local_products[index].QUANTITY < this.local_products[index].INVENTORY){
                this.local_products[index].QUANTITY++
                this.local_total_points = this.local_total_points+(this.local_products[index].POINTS_UNIT_VALUE + this.local_products[index].POINTS_UNIT_SHIPPING)
            }
        },
    },
}
</script>